import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { ClassifierUrl } from './ClassifierUrl';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { ClassifierSchema } from '../schema';

const getClassifier = (id?: number) =>
  apiClient
    .get(expand(ClassifierUrl.CLASSIFIER, { id }))
    .then((response) => ClassifierSchema.parseFormData(response.data));

export const useGetClassifierQuery = createApiQueryHook(
  ['classifier'],
  getClassifier
);
